<template>
  <v-app theme="dark">
    <v-main>
      <v-container>
        <h1 class="page-title mt-10">
          {{ $t('error.title') }}
        </h1>

        <p>
          {{ $t('error.errorMessage') }}
        </p>

        <p>
          {{ $t('error.contactMessage') }}
        </p>
      </v-container>
    </v-main>

    <app-footer color="transparent">
      <footer-button color="primary" @click="whatsapp">
        {{ $t('error.supportButton') }}
      </footer-button>
    </app-footer>
  </v-app>
</template>
<script setup lang="ts">
  import { useUtils } from '@/composables/useUtils'

  const util = useUtils()
  const whatsapp = () => {
    util.openBikeHeroWhatsApp()
  }
</script>
<style lang="">

</style>
